import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import { Link } from 'react-router-dom'
import Y from '../../y18n'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import LinearProgress from '@material-ui/core/LinearProgress'
import TopNavigationAppShell from '../../common/top-navigation-app-shell'
import * as accountActions from '../../store/accounts'
import Styles from '../../common/styles'

const mapStateToProps = state => ({
  accounts: state.accounts,
  locales: state.locales
})

const mapDispatchToProps = dispatch => ({
  accountActions: bindActionCreators(accountActions, dispatch)
})

class ForgotPasswordPage extends Component {
  state = {
    email: '',
    disabled: false
  }

  handleSubmit = e => {
    e.preventDefault()
    this.props.accountActions.forgotPassword({email: this.state.email}).then(res => {
      if (!this.props.accounts.error) {
        this.setState({ email: '', disabled: true })
        this.props.history.push('/forgot-password-sent')
      }
    })
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value
    })
  }

  render () {
    const { classes, locales, accounts } = this.props
    return (
      <TopNavigationAppShell
        content={
          <div className={classes.accountContainer}>
            <Link to='/'>
              <img src={locales.logo} alt='logo' className={classes.logo} />
            </Link>
            <Paper elevation={3} square style={{ marginTop: '40px', marginBottom: '20px' }}>
              {accounts.loading && <LinearProgress />}
              <div className={classes.content}>
                <div className={classes.textRow}>
                  <Typography variant='title'>{Y`Forgot password`}</Typography>
                  <Typography variant='body2' className={classes.spacer}>
                    {Y`We will send you an email with a link where you can set a new password. You should receive an email from us shortly, please make sure to check the junk folder`}
                  </Typography>
                </div>
                <form onSubmit={e => this.handleSubmit(e)}>
                  <TextField
                    className={classes.spacer}
                    label={Y`Email`}
                    id='email'
                    value={this.state.email}
                    onChange={this.handleChange('email')}
                    InputProps={{
                      disableUnderline: true,
                      classes: {
                        root: classes.root,
                        input: classes.input
                      }
                    }}
                    InputLabelProps={{
                      shrink: true,
                      className: classes.formLabel
                    }}
                    fullWidth
                  />
                  {accounts.error &&
                    <div className={classes.textRow}>
                      <Typography variant='body1' className={classes.spacer} style={{ color: 'red' }}>
                        {accounts.error}
                      </Typography>
                    </div>}
                  <div className={classes.buttonRow}>
                    <Button
                      variant='raised'
                      color='primary'
                      disabled={this.state.disabled}
                      style={{ color: '#fff' }}
                      type='submit'
                    >{Y`Send a password recovery link`}</Button>
                  </div>
                </form>
              </div>
            </Paper>
            <div className={classes.textRow}>
              <Typography variant='body1' className={classes.spacer}>
                {Y`If you know your password, log in`}
                {' '}
                <Link to={'/login'} className={classes.themeLink}>{Y`here`}</Link>
              </Typography>
            </div>
          </div>
        }
        pageName={'Forgot password'}
      />
    )
  }
}

ForgotPasswordPage = connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordPage)
export default withStyles(Styles)(ForgotPasswordPage)



// WEBPACK FOOTER //
// ./src/pages/account/forgot-password.js